import request from 'crm/utils/request'
import {format} from 'utils'
import api from 'crm/common/api/group-sop'
import {stringify} from 'qs'

export async function tasksInfo(params = {}) {
    return request(`${format(api.tasksInfo.url, {task_id: params.task_id})}?${stringify(params)}`)
}

export async function createTasks(payload = {}) {
    return request(api.createTasks.url, {
        method: api.createTasks.type,
        body: payload.body,
    })
}

export async function tasksModify(payload = {}) {
    return request(`${format(api.tasksModify.url, {task_id: payload.task_id})}`, {
        method: api.tasksModify.type,
        body: payload.body,
    })
}
